import React, { useState, useEffect } from 'react';
import { Badge, Button, Form, InputGroup, Modal, Table, Card } from 'react-bootstrap';
import './StaffManagement.css';
import { oneKlicks } from '../../SDK/oneclick';

const RolesManagement = () => {
    const [roles, setRoles] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingRole, setEditingRole] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [formData, setFormData] = useState({
        role_name: '',
        permissions: [] // Array of objects with {value, local: boolean, global: boolean}
    });

    // Available permissions for roles
    const availablePermissions = [
        { label: 'View Dashboard', value: 'view_dashboard' },
        { label: 'View Profile', value: 'view_profile' },
        { label: 'View Inbox', value: 'view_inbox' ,
            children: [
                { label: 'View Inbox', value: 'view_inbox' },
                { label: 'Edit Inbox', value: 'edit_inbox' },
                { label: 'Delete Inbox', value: 'delete_inbox' },
            ] 
        },
        { label: 'Manage Profile', value: 'manage_profile' ,
            children: [
                { label: 'View Profile', value: 'view_profile' },
                { label: 'Edit Profile', value: 'edit_profile' }
            ] 
        },
        { 
            label: 'Manage Appointments', 
            value: 'manage_appointments', 
            children: [
                { label: 'View Appointments', value: 'view_appointments' },
                { label: 'Appointment Settings', value: 'appointment_settings' },
                { label: 'Manage Appointments', value: 'manage_appointments' },
                { label: 'View Appointment Schedules', value: 'view_appointment_schedules' },
                { label: 'Manage Appointment Schedules', value: 'manage_appointment_schedules' },
                { label: 'View Appointment Slots', value: 'view_appointment_slots' },
                { label: 'Manage Appointment Slots', value: 'manage_appointment_slots' },
            ] 
        },
        { label: 'Manage Articles', value: 'manage_articles' ,
            children: [
                { label: 'Add Articles', value: 'superadmin_add_articles' },
                { label: 'View Articles', value: 'superadmin_view_articles' },
                { label: 'Edit Articles', value: 'superadmin_edit_articles' },
                { label: 'Delete Articles', value: 'superadmin_delete_articles' },
            ] 
        },
        { label: 'Manage Post Frames', value: 'manage_postframes' ,
            children: [
                { label: 'View Post Frames', value: 'view_postframes' },
                { label: 'Edit Post Frames', value: 'edit_postframes' },
                { label: 'Delete Post Frames', value: 'delete_postframes' },
            ] 
        },
        { label: 'Manage Posts', value: 'manage_posts' ,
            children: [
                { label: 'View Posts', value: 'view_posts' },
                { label: 'Edit Posts', value: 'edit_posts' },
                { label: 'Delete Posts', value: 'delete_posts' },
            ] 
        },
        { label: 'Manage Doctors', value: 'manage_doctors' ,
            children: [
                { label: 'Add Doctors', value: 'add_doctors' },
                { label: 'View Doctors', value: 'view_doctors' },
                { label: 'Manage Doctors', value: 'manage_doctors' },
                { label: 'Edit Doctors', value: 'edit_doctors' },
                { label: 'Delete Doctors', value: 'delete_doctors' },
                { label: 'View Doctor Schedules', value: 'view_doctor_schedules' },
                { label: 'Manage Doctor Schedules', value: 'manage_doctor_schedules' },
                { label: 'View Doctor Slots', value: 'view_doctor_slots' },
                { label: 'Manage Doctor Slots', value: 'manage_doctor_slots' },
            ] 
        },
        { label: 'Manage Patients', value: 'manage_patients' ,
            children: [
                { label: 'Add Patients', value: 'add_patients' },
                { label: 'View Patients', value: 'view_patients' },
                { label: 'Manage Patients', value: 'manage_patients' },
                { label: 'Edit Patients', value: 'edit_patients' },
                { label: 'Delete Patients', value: 'delete_patients' },
            ] 
        },
        { label: 'Manage Settings', value: 'manage_settings' ,
            children: [
                { label: 'Site Settings', value: 'site_settings' , children: [
                    { label: 'View Settings', value: 'site_settings_view_settings' },
                    { label: 'Edit Settings', value: 'site_settings_edit_settings' },
                ] },
                { label: 'Color Settings', value: 'color_settings' , children: [
                    { label: 'View Settings', value: 'color_settings_view_settings' },
                    { label: 'Edit Settings', value: 'color_settings_edit_settings' },
                ] },
                { label: 'Contact Social Settings', value: 'contact_social_settings' , children: [
                    { label: 'View Settings', value: 'contact_social_settings_view_settings' },
                    { label: 'Edit Settings', value: 'contact_social_settings_edit_settings' },
                ] },
                { label: 'SEO Settings', value: 'seo_settings' , children: [
                    { label: 'View Settings', value: 'seo_settings_view_settings' },
                    { label: 'Edit Settings', value: 'seo_settings_edit_settings' },
                ] },
                { label: 'Features Settings', value: 'features_settings' , children: [
                    { label: 'View Settings', value: 'features_settings_view_settings' },
                    { label: 'Edit Settings', value: 'features_settings_edit_settings' },
                ] },
                { label: 'Payment Settings', value: 'payment_settings' , children: [
                    { label: 'View Settings', value: 'payment_settings_view_settings' },
                    { label: 'Edit Settings', value: 'payment_settings_edit_settings' },
                ] },
                { label: 'Email & SMS Settings', value: 'email_sms_settings' , children: [
                    { label: 'View Settings', value: 'email_sms_settings_view_settings' },
                    { label: 'Edit Settings', value: 'email_sms_settings_edit_settings' },
                ] },
                { label: 'Security Settings', value: 'security_settings' , children: [
                    { label: 'View Settings', value: 'security_settings_view_settings' },
                    { label: 'Edit Settings', value: 'security_settings_edit_settings' },
                ] },
                { label: 'Custom Code Settings', value: 'custom_code_settings' , children: [
                    { label: 'View Settings', value: 'custom_code_settings_view_settings' },
                    { label: 'Edit Settings', value: 'custom_code_settings_edit_settings' },
                ] },
                { label: 'Apis Settings', value: 'apis_settings' , children: [
                    { label: 'View Settings', value: 'apis_settings_view_settings' },
                    { label: 'Edit Settings', value: 'apis_settings_edit_settings' },
                ] }
            ] 
        },
        { label: 'Manage Users', value: 'manage_users' ,
            children: [
                { label: 'Manage Doctors', value: 'manage_users_manage_doctors', children: [
                    { label: 'Add Doctors', value: 'manage_users_manage_doctors_add_doctors' },
                    { label: 'View Doctors', value: 'manage_users_manage_doctors_view_doctors' },
                    { label: 'Edit Doctors', value: 'manage_users_manage_doctors_edit_doctors' },
                    { label: 'Delete Doctors', value: 'manage_users_manage_doctors_delete_doctors' },
                ] },
                { label: 'Manage Hospitals', value: 'manage_users_manage_hospitals', children: [
                    { label: 'Add Hospitals', value: 'manage_users_manage_hospitals_add_hospitals' },
                    { label: 'View Hospitals', value: 'manage_users_manage_hospitals_view_hospitals' },
                    { label: 'Edit Hospitals', value: 'manage_users_manage_hospitals_edit_hospitals' },
                    { label: 'Delete Hospitals', value: 'manage_users_manage_hospitals_delete_hospitals' },
                ] },
                { label: 'Manage Pharmacies', value: 'manage_users_manage_pharmacies', children: [
                    { label: 'Add Pharmacies', value: 'manage_users_manage_pharmacies_add_pharmacies' },
                    { label: 'View Pharmacies', value: 'manage_users_manage_pharmacies_view_pharmacies' },
                    { label: 'Edit Pharmacies', value: 'manage_users_manage_pharmacies_edit_pharmacies' },
                    { label: 'Delete Pharmacies', value: 'manage_users_manage_pharmacies_delete_pharmacies' },
                ] },
                { label: 'Manage Patients', value: 'manage_users_manage_patients', children: [
                    { label: 'Add Patients', value: 'manage_users_manage_patients_add_patients' },
                    { label: 'View Patients', value: 'manage_users_manage_patients_view_patients' },
                    { label: 'Edit Patients', value: 'manage_users_manage_patients_edit_patients' },
                    { label: 'Delete Patients', value: 'manage_users_manage_patients_delete_patients' },
                ] },
                { label: 'Manage Insurance Companies', value: 'manage_users_manage_insurance_companies', children: [
                    { label: 'Add Insurance Companies', value: 'manage_users_manage_insurance_companies_add_insurance_companies' },
                    { label: 'View Insurance Companies', value: 'manage_users_manage_insurance_companies_view_insurance_companies' },
                    { label: 'Edit Insurance Companies', value: 'manage_users_manage_insurance_companies_edit_insurance_companies' },
                    { label: 'Delete Insurance Companies', value: 'manage_users_manage_insurance_companies_delete_insurance_companies' },
                ] },
                { label: 'Manage Blood Banks', value: 'manage_users_manage_blood_banks', children: [
                    { label: 'Add Blood Banks', value: 'manage_users_manage_blood_banks_add_blood_banks' },
                    { label: 'View Blood Banks', value: 'manage_users_manage_blood_banks_view_blood_banks' },
                    { label: 'Edit Blood Banks', value: 'manage_users_manage_blood_banks_edit_blood_banks' },
                    { label: 'Delete Blood Banks', value: 'manage_users_manage_blood_banks_delete_blood_banks' },
                ] },
                { label: 'Manage Ambulances', value: 'manage_users_manage_ambulances', children: [
                    { label: 'Add Ambulances', value: 'manage_users_manage_ambulances_add_ambulances' },
                    { label: 'View Ambulances', value: 'manage_users_manage_ambulances_view_ambulances' },
                    { label: 'Edit Ambulances', value: 'manage_users_manage_ambulances_edit_ambulances' },
                    { label: 'Delete Ambulances', value: 'manage_users_manage_ambulances_delete_ambulances' },
                ] },
                { label: 'Manage Medical Stores', value: 'manage_users_manage_medical_stores', children: [
                    { label: 'Add Medical Stores', value: 'manage_users_manage_medical_stores_add_medical_stores' },
                    { label: 'View Medical Stores', value: 'manage_users_manage_medical_stores_view_medical_stores' },
                    { label: 'Edit Medical Stores', value: 'manage_users_manage_medical_stores_edit_medical_stores' },
                    { label: 'Delete Medical Stores', value: 'manage_users_manage_medical_stores_delete_medical_stores' },
                ] },
                { label: 'Manage Medical Students', value: 'manage_users_manage_medical_students', children: [
                    { label: 'Add Medical Students', value: 'manage_users_manage_medical_students_add_medical_students' },
                    { label: 'View Medical Students', value: 'manage_users_manage_medical_students_view_medical_students' },
                    { label: 'Edit Medical Students', value: 'manage_users_manage_medical_students_edit_medical_students' },
                    { label: 'Delete Medical Students', value: 'manage_users_manage_medical_students_delete_medical_students' },
                ] },
                { label: 'Manage Medical Technicians', value: 'manage_users_manage_medical_technicians', children: [
                    { label: 'Add Medical Technicians', value: 'manage_users_manage_medical_technicians_add_medical_technicians' },
                    { label: 'View Medical Technicians', value: 'manage_users_manage_medical_technicians_view_medical_technicians' },
                    { label: 'Edit Medical Technicians', value: 'manage_users_manage_medical_technicians_edit_medical_technicians' },
                    { label: 'Delete Medical Technicians', value: 'manage_users_manage_medical_technicians_delete_medical_technicians' },
                ] },
                { label: 'Manage Medical Labs', value: 'manage_users_manage_medical_labs', children: [
                    { label: 'Add Medical Labs', value: 'manage_users_manage_medical_labs_add_medical_labs' },
                    { label: 'View Medical Labs', value: 'manage_users_manage_medical_labs_view_medical_labs' },
                    { label: 'Edit Medical Labs', value: 'manage_users_manage_medical_labs_edit_medical_labs' },
                    { label: 'Delete Medical Labs', value: 'manage_users_manage_medical_labs_delete_medical_labs' },
                ] },
                { label: 'Manage Medical Colleges', value: 'manage_users_manage_medical_colleges', children: [
                    { label: 'Add Medical Colleges', value: 'manage_users_manage_medical_colleges_add_medical_colleges' },
                    { label: 'View Medical Colleges', value: 'manage_users_manage_medical_colleges_view_medical_colleges' },
                    { label: 'Edit Medical Colleges', value: 'manage_users_manage_medical_colleges_edit_medical_colleges' },
                    { label: 'Delete Medical Colleges', value: 'manage_users_manage_medical_colleges_delete_medical_colleges' },
                ] },
                { label: 'Manage User Verification Request', value: 'manage_users_manage_user_verification_request', children: [
                    { label: 'Add User Verification Request', value: 'manage_users_manage_user_verification_request_add_user_verification_request' },
                    { label: 'View User Verification Request', value: 'manage_users_manage_user_verification_request_view_user_verification_request' },
                    { label: 'Edit User Verification Request', value: 'manage_users_manage_user_verification_request_edit_user_verification_request' },
                    { label: 'Delete User Verification Request', value: 'manage_users_manage_user_verification_request_delete_user_verification_request' },
                ] },

            ] 
        },
        { label: 'Manage Pharmacies', value: 'manage_pharmacies' ,
            children: [
                { label: 'Manage Pharmacy Products', value: 'manage_pharmacies_manage_pharmacy_products', children: [
                    { label: 'Add Pharmacy Products', value: 'manage_pharmacies_manage_pharmacy_products_add_pharmacy_products' },
                    { label: 'View Pharmacy Products', value: 'manage_pharmacies_manage_pharmacy_products_view_pharmacy_products' },
                    { label: 'Edit Pharmacy Products', value: 'manage_pharmacies_manage_pharmacy_products_edit_pharmacy_products' },
                    { label: 'Delete Pharmacy Products', value: 'manage_pharmacies_manage_pharmacy_products_delete_pharmacy_products' },
                ] },
                { label: 'Manage Pharmacy Categories', value: 'manage_pharmacies_manage_pharmacy_categories', children: [
                    { label: 'Add Pharmacy Categories', value: 'manage_pharmacies_manage_pharmacy_categories_add_pharmacy_categories' },
                    { label: 'View Pharmacy Categories', value: 'manage_pharmacies_manage_pharmacy_categories_view_pharmacy_categories' },
                    { label: 'Edit Pharmacy Categories', value: 'manage_pharmacies_manage_pharmacy_categories_edit_pharmacy_categories' },
                    { label: 'Delete Pharmacy Categories', value: 'manage_pharmacies_manage_pharmacy_categories_delete_pharmacy_categories' },
                ] },
                { label: 'Manage Pharmacy Brands', value: 'manage_pharmacies_manage_pharmacy_brands', children: [
                    { label: 'Add Pharmacy Brands', value: 'manage_pharmacies_manage_pharmacy_brands_add_pharmacy_brands' },
                    { label: 'View Pharmacy Brands', value: 'manage_pharmacies_manage_pharmacy_brands_view_pharmacy_brands' },
                    { label: 'Edit Pharmacy Brands', value: 'manage_pharmacies_manage_pharmacy_brands_edit_pharmacy_brands' },
                    { label: 'Delete Pharmacy Brands', value: 'manage_pharmacies_manage_pharmacy_brands_delete_pharmacy_brands' },
                ] },
            ] 
        },
        { label: 'Manage Banners', value: 'manage_banners' ,
            children: [
                { label: 'Manage Banners', value: 'manage_banners_manage_banners', children: [
                    { label: 'Add Banners', value: 'manage_banners_manage_banners_add_banners' },
                    { label: 'View Banners', value: 'manage_banners_manage_banners_view_banners' },
                    { label: 'Edit Banners', value: 'manage_banners_manage_banners_edit_banners' },
                    { label: 'Delete Banners', value: 'manage_banners_manage_banners_delete_banners' },
                ] },
                { label: 'Manage Banner Settings', value: 'manage_banners_manage_banner_settings', children: [
                    { label: 'Add Banner Settings', value: 'manage_banners_manage_banner_settings_add_banner_settings' },
                    { label: 'View Banner Settings', value: 'manage_banners_manage_banner_settings_view_banner_settings' },
                    { label: 'Edit Banner Settings', value: 'manage_banners_manage_banner_settings_edit_banner_settings' },
                    { label: 'Delete Banner Settings', value: 'manage_banners_manage_banner_settings_delete_banner_settings' },
                ] },
            ] 
        },
        { label: 'Manage Front End', value: 'manage_front_end' ,
            children: [
                { label: 'Manage Slides', value: 'manage_front_end_manage_slides', children: [
                    { label: 'Add Slides', value: 'manage_front_end_manage_slides_add_slides' },
                    { label: 'View Slides', value: 'manage_front_end_manage_slides_view_slides' },
                    { label: 'Edit Slides', value: 'manage_front_end_manage_slides_edit_slides' },
                    { label: 'Delete Slides', value: 'manage_front_end_manage_slides_delete_slides' },
                ] },
                { label: 'Manage About Us', value: 'manage_front_end_manage_about_us', children: [
                    { label: 'Add About Us', value: 'manage_front_end_manage_about_us_add_about_us' },
                    { label: 'View About Us', value: 'manage_front_end_manage_about_us_view_about_us' },
                    { label: 'Edit About Us', value: 'manage_front_end_manage_about_us_edit_about_us' },
                    { label: 'Delete About Us', value: 'manage_front_end_manage_about_us_delete_about_us' },
                ] },
                { label: 'Manage Contact Us', value: 'manage_front_end_manage_contact_us', children: [
                    { label: 'Add Contact Us', value: 'manage_front_end_manage_contact_us_add_contact_us' },
                    { label: 'View Contact Us', value: 'manage_front_end_manage_contact_us_view_contact_us' },
                    { label: 'Edit Contact Us', value: 'manage_front_end_manage_contact_us_edit_contact_us' },
                    { label: 'Delete Contact Us', value: 'manage_front_end_manage_contact_us_delete_contact_us' },
                ] },
                { label: 'Manage Privacy Policy', value: 'manage_front_end_manage_privacy_policy', children: [
                    { label: 'Add Privacy Policy', value: 'manage_front_end_manage_privacy_policy_add_privacy_policy' },
                    { label: 'View Privacy Policy', value: 'manage_front_end_manage_privacy_policy_view_privacy_policy' },
                    { label: 'Edit Privacy Policy', value: 'manage_front_end_manage_privacy_policy_edit_privacy_policy' },
                    { label: 'Delete Privacy Policy', value: 'manage_front_end_manage_privacy_policy_delete_privacy_policy' },
                ] },
                { label: 'Manage Terms & Conditions', value: 'manage_front_end_manage_terms_conditions', children: [
                    { label: 'Add Terms & Conditions', value: 'manage_front_end_manage_terms_conditions_add_terms_conditions' },
                    { label: 'View Terms & Conditions', value: 'manage_front_end_manage_terms_conditions_view_terms_conditions' },
                    { label: 'Edit Terms & Conditions', value: 'manage_front_end_manage_terms_conditions_edit_terms_conditions' },
                    { label: 'Delete Terms & Conditions', value: 'manage_front_end_manage_terms_conditions_delete_terms_conditions' },
                ] },
                { label: 'Manage FAQs', value: 'manage_front_end_manage_faqs', children: [
                    { label: 'Add FAQs', value: 'manage_front_end_manage_faqs_add_faqs' },
                    { label: 'View FAQs', value: 'manage_front_end_manage_faqs_view_faqs' },
                    { label: 'Edit FAQs', value: 'manage_front_end_manage_faqs_edit_faqs' },
                    { label: 'Delete FAQs', value: 'manage_front_end_manage_faqs_delete_faqs' },
                ] },
                { label: 'Manage Blog', value: 'manage_front_end_manage_blog', children: [
                    { label: 'Add Blog', value: 'manage_front_end_manage_blog_add_blog' },
                    { label: 'View Blog', value: 'manage_front_end_manage_blog_view_blog' },
                    { label: 'Edit Blog', value: 'manage_front_end_manage_blog_edit_blog' },
                    { label: 'Delete Blog', value: 'manage_front_end_manage_blog_delete_blog' },
                ] },
                { label: 'Manage Blog Categories', value: 'manage_front_end_manage_blog_categories', children: [
                    { label: 'Add Blog Categories', value: 'manage_front_end_manage_blog_categories_add_blog_categories' },
                    { label: 'View Blog Categories', value: 'manage_front_end_manage_blog_categories_view_blog_categories' },
                    { label: 'Edit Blog Categories', value: 'manage_front_end_manage_blog_categories_edit_blog_categories' },
                    { label: 'Delete Blog Categories', value: 'manage_front_end_manage_blog_categories_delete_blog_categories' },
                ] },
                { label: 'Manage Blog Tags', value: 'manage_front_end_manage_blog_tags', children: [
                    { label: 'Add Blog Tags', value: 'manage_front_end_manage_blog_tags_add_blog_tags' },
                    { label: 'View Blog Tags', value: 'manage_front_end_manage_blog_tags_view_blog_tags' },
                    { label: 'Edit Blog Tags', value: 'manage_front_end_manage_blog_tags_edit_blog_tags' },
                    { label: 'Delete Blog Tags', value: 'manage_front_end_manage_blog_tags_delete_blog_tags' },
                ] }
            ] 
        },
        { label: 'Manage staff', value: 'manage_staff' ,
            children: [
                { label: 'Manage staff', value: 'manage_staff', children: [
                    { label: 'Add staff', value: 'add_staff' },
                    { label: 'View staff', value: 'view_staff' },
                    { label: 'Edit staff', value: 'edit_staff' },
                    { label: 'Delete staff', value: 'delete_staff' },
                ] },
                { label: 'Manage roles', value: 'manage_roles', children: [
                    { label: 'Add roles', value: 'add_roles' },
                    { label: 'View roles', value: 'view_roles' },
                    { label: 'Edit roles', value: 'edit_roles' },
                    { label: 'Delete roles', value: 'delete_roles' },
                ] },
                { label: 'Manage staff transfer', value: 'manage_staff_transfer', children: [
                    { label: 'Add staff transfer', value: 'add_staff_transfer' },
                    { label: 'View staff transfer', value: 'view_staff_transfer' },
                    { label: 'Edit staff transfer', value: 'edit_staff_transfer' },
                    { label: 'Delete staff transfer', value: 'delete_staff_transfer' },
                ] },
            ] 
        },
        { label: 'View Reports', value: 'view_reports' ,
            children: [
                { label: 'Add Reports', value: 'add_reports' },
                { label: 'View Reports', value: 'view_reports' },
                { label: 'Edit Reports', value: 'edit_reports' },
                { label: 'Delete Reports', value: 'delete_reports' },
            ] 
        },
        { label: 'Manage Content', value: 'manage_content' ,
            children: [
                { label: 'View Content', value: 'view_content' },
                { label: 'Edit Content', value: 'edit_content' },
                { label: 'Delete Content', value: 'delete_content' },
            ] 
        },
        { label: 'System Administration', value: 'system_admin' ,
            children: [
                { label: 'Add System Administration', value: 'add_system_administration' },
                { label: 'View System Administration', value: 'view_system_administration' },
                { label: 'Edit System Administration', value: 'edit_system_administration' },
                { label: 'Delete System Administration', value: 'delete_system_administration' },
            ] 
        },
        { label: 'Manage Notifications', value: 'manage_notifications' ,
            children: [
                { label: 'Add Notifications', value: 'add_notifications' },
                { label: 'View Notifications', value: 'view_notifications' },
                { label: 'Edit Notifications', value: 'edit_notifications' },
                { label: 'Delete Notifications', value: 'delete_notifications' },
            ] 
        },
        { label: 'Manage Logs', value: 'manage_logs' ,
            children: [
                { label: 'View Logs', value: 'view_logs' },
                { label: 'Edit Logs', value: 'edit_logs' },
                { label: 'Delete Logs', value: 'delete_logs' },
            ] 
        },
        { label: 'Manage Packages', value: 'manage_packages' ,
            children: [
                { label: 'Add Packages', value: 'add_packages' },
                { label: 'View Packages', value: 'view_packages' },
                { label: 'Edit Packages', value: 'edit_packages' },
                { label: 'Delete Packages', value: 'delete_packages' },
            ] 
        },
        { label: 'Manage finances', value: 'manage_finances' ,
            children: [
                { label: 'Income Management', value: 'income_management', children: [
                    { label: 'Add Income', value: 'add_income' },
                    { label: 'View Income', value: 'view_income', children: [
                        { label: 'Add Payments', value: 'add_payments' }
                    ] },
                    { label: 'Edit Income', value: 'edit_income' },
                    { label: 'Delete Income', value: 'delete_income' },
                ] },
                { label: 'Expenses Management', value: 'expenses_management', children: [
                    { label: 'Add Expenses', value: 'add_expenses' },
                    { label: 'View Expenses', value: 'view_expenses' },
                    { label: 'Edit Expenses', value: 'edit_expenses' },
                    { label: 'Delete Expenses', value: 'delete_expenses' },
                ] },
                { label: 'Invoices', value: 'invoices', children: [
                    { label: 'Add Invoices', value: 'add_invoices' },
                    { label: 'View Invoices', value: 'view_invoices' },
                    { label: 'Edit Invoices', value: 'edit_invoices' },
                    { label: 'Delete Invoices', value: 'delete_invoices' },
                ] },
            ] 
        },
    ];

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const tableSchema = '';
            const tableName = 'roles';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = {};
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log('fetchRoles response :', response);
            
            if (response.success && response.data) {
                // Parse permissions JSON string for each role
                const parsedRoles = response.data.map(role => {
                    let parsedPermissions = [];
                    try {
                        // If permissions is a string, parse it as JSON
                        if (typeof role.permissions === 'string') {
                            parsedPermissions = JSON.parse(role.permissions);
                        } else if (Array.isArray(role.permissions)) {
                            parsedPermissions = role.permissions;
                        }
                    } catch (parseError) {
                        console.error('Error parsing permissions for role:', role.role_name, parseError);
                        parsedPermissions = [];
                    }
                    
                    return {
                        ...role,
                        permissions: parsedPermissions
                    };
                });
                
                setRoles(parsedRoles);
            } else {
                console.error('Error fetching roles:', response.message);
                setRoles([]);
            }
        } catch (error) {
            console.error('Error fetching roles:', error);
            setRoles([]);
        }
    };

    const handleAdd = () => {
        setEditingRole(null);
        setFormData({
            role_name: '',
            permissions: []
        });
        setIsModalVisible(true);
    };

    const handleEdit = (role) => {
        setEditingRole(role);
        // Role permissions should already be parsed objects from fetchRoles
        // But handle both string and object formats for safety
        const formattedPermissions = role.permissions.map(permission => {
            if (typeof permission === 'string') {
                return { value: permission, local: true, global: false };
            }
            // Ensure permission has the correct structure
            return {
                value: permission.value || permission,
                local: permission.local !== undefined ? permission.local : false,
                global: permission.global !== undefined ? permission.global : false
            };
        });
        
        setFormData({
            role_name: role.role_name,
            permissions: formattedPermissions
        });
        setIsModalVisible(true);
    };

    const handleDelete = async (roleId) => {
        if (window.confirm('Are you sure you want to delete this role?')) {
            try {
                const tableSchema = '';
                const tableName = 'roles';
                const conditions = {
                    id: roleId
                };
                
                const response = await oneKlicks.delete(tableSchema, tableName, conditions);
                if (response.success) {
                    setRoles(roles.filter(role => role.id !== roleId));
                    alert('Role deleted successfully');
                } else {
                    console.error('Error deleting role:', response.message);
                    alert('Error deleting role: ' + response.message);
                }
            } catch (error) {
                console.error('Error deleting role:', error);
                alert('Error deleting role: ' + error.message);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.role_name.trim()) {
            alert('Please enter a role name');
            return;
        }

        if (formData.permissions.length === 0) {
            alert('Please select at least one permission');
            return;
        }

        try {
            if (editingRole) {
                // Update existing role
                const tableSchema = '';
                const tableName = 'roles';
                const conditions = {
                    id: editingRole.id
                };
                const data = {
                    role_name: formData.role_name,
                    permissions: JSON.stringify(formData.permissions)
                };
                
                const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
                if (response.success) {
                    // Update local state
                    const updatedRoles = roles.map(role =>
                        role.id === editingRole.id
                            ? { ...role, role_name: formData.role_name, permissions: formData.permissions }
                            : role
                    );
                    setRoles(updatedRoles);
                    alert('Role updated successfully');
                } else {
                    console.error('Error updating role:', response.message);
                    alert('Error updating role: ' + response.message);
                }
            } else {
                // Add new role
                const tableSchema = '';
                const tableName = 'roles';
                const conditions = {
                    role_name: formData.role_name
                };
                const data = {
                    role_name: formData.role_name,
                    permissions: JSON.stringify(formData.permissions),
                    created_at: new Date().toISOString().split('T')[0],
                    users_count: 0
                };
                
                const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
                if (response.success) {
                    // Add to local state
                    const newRole = {
                        id: response.data?.id || Date.now(),
                        role_name: formData.role_name,
                        permissions: formData.permissions,
                        created_at: data.created_at,
                        users_count: 0
                    };
                    setRoles([...roles, newRole]);
                    alert('Role created successfully');
                } else {
                    console.error('Error creating role:', response.message);
                    alert('Error creating role: ' + response.message);
                }
            }

            setIsModalVisible(false);
        } catch (error) {
            console.error('Error saving role:', error);
        }
    };

    // Helper function to collect all permission values from nested structure
    const getAllPermissionValues = (permissionObj) => {
        const values = [permissionObj.value];
        if (permissionObj.children) {
            permissionObj.children.forEach(child => {
                values.push(...getAllPermissionValues(child));
            });
        }
        return values;
    };

    // Helper function to check if a permission exists in formData
    const getPermissionState = (permissionValue) => {
        const permission = formData.permissions.find(p => p.value === permissionValue);
        return permission || { value: permissionValue, local: false, global: false };
    };

    // Helper function to check if a permission is selected (either local or global)
    const isPermissionSelected = (permissionValue) => {
        const permission = getPermissionState(permissionValue);
        return permission.local || permission.global;
    };

    // Helper function to check if a permission or its children are selected
    const isPermissionOrChildrenSelected = (permissionObj) => {
        const allValues = getAllPermissionValues(permissionObj);
        return allValues.some(value => isPermissionSelected(value));
    };

    // Helper function to check if a permission is partially selected (some children selected)
    const isPermissionPartiallySelected = (permissionObj) => {
        if (!permissionObj.children) return false;
        const selectedChildren = permissionObj.children.filter(child => 
            isPermissionSelected(child.value) || isPermissionOrChildrenSelected(child)
        );
        return selectedChildren.length > 0 && selectedChildren.length < permissionObj.children.length;
    };

    const handlePermissionChange = (permission, isChecked) => {
        const allValues = getAllPermissionValues(permission);
        
        if (isChecked) {
            // Add this permission and all its children with both local and global set to true
            const newPermissions = [...formData.permissions];
            allValues.forEach(value => {
                const existingIndex = newPermissions.findIndex(p => p.value === value);
                if (existingIndex >= 0) {
                    newPermissions[existingIndex] = { value, local: true, global: true };
                } else {
                    newPermissions.push({ value, local: true, global: true });
                }
            });
            setFormData({
                ...formData,
                permissions: newPermissions
            });
        } else {
            // Remove this permission and all its children
            setFormData({
                ...formData,
                permissions: formData.permissions.filter(p => !allValues.includes(p.value))
            });
        }
    };

    const handleLocalPermissionChange = (permissionValue, isChecked) => {
        const existingIndex = formData.permissions.findIndex(p => p.value === permissionValue);
        let updatedPermissions = [...formData.permissions];
        
        if (existingIndex >= 0) {
            updatedPermissions[existingIndex] = {
                ...updatedPermissions[existingIndex],
                local: isChecked
            };
        } else {
            updatedPermissions.push({ value: permissionValue, local: isChecked, global: false });
        }
        
        setFormData({
            ...formData,
            permissions: updatedPermissions
        });
    };

    const handleGlobalPermissionChange = (permissionValue, isChecked) => {
        const existingIndex = formData.permissions.findIndex(p => p.value === permissionValue);
        let updatedPermissions = [...formData.permissions];
        
        if (existingIndex >= 0) {
            updatedPermissions[existingIndex] = {
                ...updatedPermissions[existingIndex],
                global: isChecked
            };
        } else {
            updatedPermissions.push({ value: permissionValue, local: false, global: isChecked });
        }
        
        setFormData({
            ...formData,
            permissions: updatedPermissions
        });
    };

    // Handle clicking on parent permission label to select/deselect all children
    const handleParentLabelClick = (permission) => {
        const allValues = getAllPermissionValues(permission);
        const currentStates = allValues.map(value => getPermissionState(value));
        const hasAnySelected = currentStates.some(state => state.local || state.global);
        
        if (hasAnySelected) {
            // Deselect all permissions
            setFormData({
                ...formData,
                permissions: formData.permissions.filter(p => !allValues.includes(p.value))
            });
        } else {
            // Select all permissions with both local and global
            const newPermissions = [...formData.permissions];
            allValues.forEach(value => {
                const existingIndex = newPermissions.findIndex(p => p.value === value);
                if (existingIndex >= 0) {
                    newPermissions[existingIndex] = { value, local: true, global: true };
                } else {
                    newPermissions.push({ value, local: true, global: true });
                }
            });
            setFormData({
                ...formData,
                permissions: newPermissions
            });
        }
    };

    // Check if a parent permission group has any selected children
    const hasSelectedChildren = (permission) => {
        const allValues = getAllPermissionValues(permission);
        return allValues.some(value => {
            const state = getPermissionState(value);
            return state.local || state.global;
        });
    };

    // Check if all children of a parent permission are selected
    const allChildrenSelected = (permission) => {
        const allValues = getAllPermissionValues(permission);
        return allValues.every(value => {
            const state = getPermissionState(value);
            return state.local && state.global;
        });
    };

    const filteredRoles = roles.filter(role =>
        role.role_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Helper function to find permission label recursively
    const findPermissionLabel = (permissions, targetValue) => {
        for (const permission of permissions) {
            if (permission.value === targetValue) {
                return permission.label;
            }
            if (permission.children) {
                const found = findPermissionLabel(permission.children, targetValue);
                if (found) return found;
            }
        }
        return targetValue; // Return the value itself if not found
    };

    const getPermissionLabel = (permissionValue) => {
        return findPermissionLabel(availablePermissions, permissionValue);
    };

    // Helper function to get all permission values from a role (including nested ones)
    const getAllRolePermissions = (rolePermissions) => {
        return rolePermissions; // Since we're now storing all individual permission values
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Roles Management</h5>
                                <Badge bg="info">Admin Roles & Permissions</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search roles..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" onClick={handleAdd}>
                                    + Add New Role
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table striped hover className="staff-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Role Name</th>
                                        <th>Permissions</th>
                                        <th>Users Count</th>
                                        <th>Created Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredRoles.map((role) => (
                                        <tr key={role.id}>
                                            <td data-label="ID">
                                                #{role.id.toString().padStart(4, '0')}
                                            </td>
                                            <td data-label="Role Name">
                                                <strong>{role.role_name}</strong>
                                            </td>
                                            <td data-label="Permissions">
                                                <div className="d-flex flex-wrap gap-1">
                                                    {role.permissions.slice(0, 2).map((permission, index) => {
                                                        const permissionObj = typeof permission === 'string' 
                                                            ? { value: permission, local: true, global: false }
                                                            : permission;
                                                        return (
                                                            <div key={index} className="d-flex flex-column align-items-center">
                                                                <Badge bg="secondary" className="text-truncate mb-1" style={{ maxWidth: '120px', fontSize: '0.75em' }}>
                                                                    {getPermissionLabel(permissionObj.value)}
                                                                </Badge>
                                                                <div className="d-flex gap-1">
                                                                    {permissionObj.local && <Badge bg="success" style={{ fontSize: '0.6em' }}>L</Badge>}
                                                                    {permissionObj.global && <Badge bg="info" style={{ fontSize: '0.6em' }}>G</Badge>}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    {role.permissions.length > 2 && (
                                                        <Badge bg="light" text="dark">
                                                            +{role.permissions.length - 2} more
                                                        </Badge>
                                                    )}
                                                </div>
                                            </td>
                                            <td data-label="Users Count">
                                                <Badge bg="info">{role.users_count}</Badge>
                                            </td>
                                            <td data-label="Created Date">{role.created_at}</td>
                                            <td data-label="Actions">
                                                <div className="d-flex gap-2" style={{ flexDirection: 'row', justifyContent: 'center', gap: '10px' }}>
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => handleEdit(role)}
                                                        className="me-2"
                                                    >
                                                        Edit
                                                    </Button>
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => handleDelete(role.id)}
                                                        disabled={role.users_count > 0}
                                                    >
                                                        Delete
                                                    </Button>
                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>

                {/* Add/Edit Role Modal */}
                <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {editingRole ? 'Edit Role' : 'Add New Role'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Role Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter role name"
                                    value={formData.role_name}
                                    onChange={(e) => setFormData({ ...formData, role_name: e.target.value })}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <Form.Label className="mb-0">Permissions</Form.Label>
                                    <div className="d-flex gap-1">
                                        <Button 
                                            variant="outline-secondary" 
                                            size="sm"
                                            onClick={() => {
                                                // Select all permissions with both local and global
                                                const allPermissions = [];
                                                const collectAllPermissions = (permissions) => {
                                                    permissions.forEach(p => {
                                                        allPermissions.push({ value: p.value, local: true, global: true });
                                                        if (p.children) {
                                                            collectAllPermissions(p.children);
                                                        }
                                                    });
                                                };
                                                collectAllPermissions(availablePermissions);
                                                setFormData({ ...formData, permissions: allPermissions });
                                            }}
                                        >
                                            Select All
                                        </Button>
                                        <Button 
                                            variant="outline-secondary" 
                                            size="sm"
                                            onClick={() => setFormData({ ...formData, permissions: [] })}
                                        >
                                            Clear All
                                        </Button>
                                    </div>
                                </div>
                                <div className="permissions-container" style={{ 
                                    maxHeight: '500px', 
                                    overflowY: 'auto', 
                                    border: '1px solid #dee2e6', 
                                    padding: '15px', 
                                    borderRadius: '5px',
                                    backgroundColor: '#f8f9fa'
                                }}>
                                    <div className="row mb-2" style={{ backgroundColor: '#e9ecef', padding: '12px', borderRadius: '4px', fontWeight: 'bold', border: '1px solid #dee2e6' }}>
                                        <div className="col-6">Permission</div>
                                        <div className="col-3 text-center">Local</div>
                                        <div className="col-3 text-center">Global</div>
                                    </div>
                                    
                                    {availablePermissions.map((permission) => (
                                        <div key={permission.value} className="permission-group mb-3">
                                            {/* Parent Permission */}
                                            <div className="permission-item" style={{ 
                                                border: '1px solid #dee2e6', 
                                                borderRadius: '6px', 
                                                marginBottom: '8px',
                                                backgroundColor: 'white',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                            }}>
                                                <div className="row align-items-center" style={{ padding: '12px' }}>
                                                    <div className="col-6">
                                                        <span 
                                                            style={{ 
                                                                fontWeight: 'bold', 
                                                                color: hasSelectedChildren(permission) ? '#007bff' : '#495057',
                                                                cursor: 'pointer',
                                                                userSelect: 'none',
                                                                padding: '4px 8px',
                                                                borderRadius: '4px',
                                                                transition: 'all 0.2s',
                                                                display: 'inline-block',
                                                                minWidth: '100px'
                                                            }}
                                                            onClick={() => handleParentLabelClick(permission)}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.backgroundColor = '#e9ecef';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.backgroundColor = 'transparent';
                                                            }}
                                                            title="Click to select/deselect all permissions in this group"
                                                        >
                                                            {permission.label}
                                                            {hasSelectedChildren(permission) && (
                                                                <span className="ms-2">
                                                                    {allChildrenSelected(permission) ? '✓' : '◐'}
                                                                </span>
                                                            )}
                                                        </span>
                                                        <small className="text-muted ms-2">
                                                            (click to select all)
                                                        </small>
                                                    </div>
                                                    <div className="col-3 text-center">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`${permission.value}_local`}
                                                            checked={getPermissionState(permission.value).local}
                                                            onChange={(e) => handleLocalPermissionChange(permission.value, e.target.checked)}
                                                        />
                                                    </div>
                                                    <div className="col-3 text-center">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`${permission.value}_global`}
                                                            checked={getPermissionState(permission.value).global}
                                                            onChange={(e) => handleGlobalPermissionChange(permission.value, e.target.checked)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Child Permissions */}
                                            {permission.children && (
                                                <div className="children-permissions" style={{ marginLeft: '20px', marginTop: '8px' }}>
                                                    {permission.children.map((child) => (
                                                        <div key={child.value} className="permission-item mb-2" style={{ 
                                                            border: '1px solid #e9ecef', 
                                                            borderRadius: '4px', 
                                                            marginBottom: '6px',
                                                            backgroundColor: 'white',
                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                                        }}>
                                                            <div className="row align-items-center" style={{ padding: '10px' }}>
                                                                <div className="col-6">
                                                                    <span style={{ color: '#6c757d', fontSize: '0.95em' }}>
                                                                        {child.label}
                                                                    </span>
                                                                </div>
                                                                <div className="col-3 text-center">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        id={`${child.value}_local`}
                                                                        checked={getPermissionState(child.value).local}
                                                                        onChange={(e) => handleLocalPermissionChange(child.value, e.target.checked)}
                                                                    />
                                                                </div>
                                                                <div className="col-3 text-center">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        id={`${child.value}_global`}
                                                                        checked={getPermissionState(child.value).global}
                                                                        onChange={(e) => handleGlobalPermissionChange(child.value, e.target.checked)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            
                                                            {/* Grandchild Permissions */}
                                                            {child.children && (
                                                                <div className="grandchildren-permissions" style={{ marginLeft: '20px', marginTop: '4px' }}>
                                                                    {child.children.map((grandchild) => (
                                                                        <div key={grandchild.value} className="permission-item mb-1" style={{ 
                                                                            border: '1px solid #f1f3f4', 
                                                                            borderRadius: '3px', 
                                                                            marginBottom: '4px',
                                                                            backgroundColor: '#fafbfc',
                                                                            boxShadow: '0 1px 1px rgba(0,0,0,0.02)'
                                                                        }}>
                                                                            <div className="row align-items-center" style={{ padding: '8px' }}>
                                                                                <div className="col-6">
                                                                                    <span style={{ color: '#6c757d', fontSize: '0.9em' }}>
                                                                                        {grandchild.label}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-3 text-center">
                                                                                    <Form.Check
                                                                                        type="checkbox"
                                                                                        id={`${grandchild.value}_local`}
                                                                                        checked={getPermissionState(grandchild.value).local}
                                                                                        onChange={(e) => handleLocalPermissionChange(grandchild.value, e.target.checked)}
                                                                                        style={{ fontSize: '0.9em' }}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-3 text-center">
                                                                                    <Form.Check
                                                                                        type="checkbox"
                                                                                        id={`${grandchild.value}_global`}
                                                                                        checked={getPermissionState(grandchild.value).global}
                                                                                        onChange={(e) => handleGlobalPermissionChange(grandchild.value, e.target.checked)}
                                                                                        style={{ fontSize: '0.9em' }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            
                                                                            {/* Great Grandchild Permissions */}
                                                                            {grandchild.children && (
                                                                                <div className="great-grandchildren-permissions" style={{ marginLeft: '20px', marginTop: '4px' }}>
                                                                                    {grandchild.children.map((greatGrandchild) => (
                                                                                        <div key={greatGrandchild.value} className="permission-item mb-1" style={{ 
                                                                                            border: '1px solid #f8f9fa', 
                                                                                            borderRadius: '3px', 
                                                                                            marginBottom: '3px',
                                                                                            backgroundColor: '#fdfdfd',
                                                                                            boxShadow: '0 1px 1px rgba(0,0,0,0.01)'
                                                                                        }}>
                                                                                            <div className="row align-items-center" style={{ padding: '6px' }}>
                                                                                                <div className="col-6">
                                                                                                    <span style={{ color: '#6c757d', fontSize: '0.85em' }}>
                                                                                                        {greatGrandchild.label}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col-3 text-center">
                                                                                                    <Form.Check
                                                                                                        type="checkbox"
                                                                                                        id={`${greatGrandchild.value}_local`}
                                                                                                        checked={getPermissionState(greatGrandchild.value).local}
                                                                                                        onChange={(e) => handleLocalPermissionChange(greatGrandchild.value, e.target.checked)}
                                                                                                        style={{ fontSize: '0.85em' }}
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="col-3 text-center">
                                                                                                    <Form.Check
                                                                                                        type="checkbox"
                                                                                                        id={`${greatGrandchild.value}_global`}
                                                                                                        checked={getPermissionState(greatGrandchild.value).global}
                                                                                                        onChange={(e) => handleGlobalPermissionChange(greatGrandchild.value, e.target.checked)}
                                                                                                        style={{ fontSize: '0.85em' }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </Form.Group>

                            <div className="d-flex justify-content-end gap-1">
                                <Button variant="secondary" onClick={() => setIsModalVisible(false)}>
                                    Cancel
                                </Button>
                                <Button variant="primary" type="submit">
                                    {editingRole ? 'Update Role' : 'Create Role'}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default RolesManagement;
